import Add from '@mui/icons-material/Add';
import { RefObject } from 'react';

import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import type { ButtonGroupProps } from '@mui/material/ButtonGroup';
import type { ButtonProps } from '@mui/material/Button';

interface CreateButtonGroupProps
  extends Omit<ButtonGroupProps, 'children' | 'onClick'> {
  label: string;
  disabled?: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  buttonProps?: ButtonProps;
  tooltipLabel?: string;
  anchorRef: RefObject<HTMLDivElement | null>;
  handleToggle: () => void;
}

export default function CreateButtonGroup({
  label,
  disabled,
  onClick,
  buttonProps,
  anchorRef,
  handleToggle,
  ...rest
}: CreateButtonGroupProps) {
  return (
    <ButtonGroup
      variant="contained"
      ref={anchorRef}
      aria-label="split button"
      disabled={disabled}
      sx={{ height: '40px' }}
      {...rest}
    >
      <Button
        startIcon={<Add />}
        onClick={onClick}
        sx={{ textTransform: 'none' }}
        {...buttonProps}
      >
        {label}
      </Button>
      <Button size="small" onClick={handleToggle} sx={{ minWidth: 0, px: 0.5 }}>
        <ArrowDropDown />
      </Button>
    </ButtonGroup>
  );
}
